import React from "react"
import "../../App.less"
import { Button, Form } from "antd"

import { observer } from "mobx-react"
import AppStore from "../../Configs/Store"

const GenericButton = observer(
  ({
    buttonStyle = "calculateFormButton",
    className,
    title,
    onClick,
    type,
    shape = "round",
    ...props
  }) => {
    const device = AppStore.device

    return (
      <Form.Item className={className}>
        <Button
          htmlType="submit"
          className={buttonStyle}
          style={device === 0 ? styles[0].buttonForm : styles[1].buttonForm}
          type="primary"
          shape={shape}
          size={"large"}
          onClick={onClick}
          {...props}
        >
          {title}
        </Button>
      </Form.Item>
    )
  }
)

const styles = {
  1: {
    buttonForm: {
      maxWidth: 297,
      height: 52,
      width: '100%'
    },
  },
  0: {
    buttonForm: {
      maxWidth: 297,
      height: 44,
      width: '100%'
    },
  },
}

export default GenericButton
